import React from "react";
import "./Poll.scss";

function Q2AnswerCopy({ pollQuestions }) {
  return (
    <p className="poll__question">
      {pollQuestions.aCopy1}
      <span className="poll__question--bold">{pollQuestions.answer}</span>{" "}
      {pollQuestions.aCopy2}
      <sup className="poll__question--sup">{pollQuestions.sup}</sup>
    </p>
  );
}

export default Q2AnswerCopy;
